import Logo from "components/Header/Logo";

const LoginHeader = () => (
  <div className="login-header">
    <div className="login-logo">
      <Logo />
    </div>
    <h2>Admin Support Dashboard</h2>
    <h3>Login</h3>
  </div>
);

export default LoginHeader;
